




























































import Vue from "vue";
export default Vue.extend({
  name: "search",
  data: function () {
    return {
      examplesList: [
        "milkshake",
        "debate",
        "guardhouse",
        "palette",
        "periphery",
        "snowboard",
        "plunger",
        "scooter",
        "segmentation",
        "conspiracy",
        "bulldozer",
        "compost",
        "vandalism",
        "replication",
        "guillotine",
        "turban",
      ],
    };
  },
  props: {
    searchTerm1: String,
    exampleButtonLoading: Boolean,
    searchButtonLoading: Boolean,
  },
  methods: {
    searchText(query: string) {
      this.$emit("textSearch", query);
    },
    randomButtons(number: number) {
      let list = [
        "milkshake",
        "debate",
        "guardhouse",
        "palette",
        "periphery",
        "snowboard",
        "plunger",
        "scooter",
        "segmentation",
        "conspiracy",
        "bulldozer",
        "compost",
        "vandalism",
        "replication",
        "guillotine",
        "turban",
      ];
      for (let i = 0; i < 3; i++) {
        const index = list.indexOf(this.examplesList[i]);
        if (index > -1) {
          list.splice(index, 1);
        }
      }
      list = this.shuffle(list);
      this.examplesList[number] = list[0];
    },
    searchButtonsText(query: string, number: number): void {
      this.$emit("buttonSearch", { query, number });
      setTimeout(this.randomButtons, 1000, number);
    },
    shuffle(array: string[]) {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
  },
  beforeMount() {
    this.examplesList = this.shuffle(this.examplesList);
  },
});
